(function($) {
  Drupal.behaviors.terms = {
    attach: function (context, settings) {
      $('a.term-trigger').click(function(e) {
        e.preventDefault();        
        $(this).closest('.term').toggleClass('is-open');
        $(this).parent('h4').next().toggle();
      });

      
      $('ul.alphabet11 li a').click(function(e) {
        e.preventDefault();
        var targetDiv = $(this).attr('href');
        /*
        $('html, body').animate({
            scrollTop: $(targetDiv).offset().top - 100
        }, 300, 'easeInOutQuint');
        */
       /*
       $('html, body').animate({
        scrollTop: $(targetDiv).offset().top - 100
      });
      */

        // focus on fist term
        $(targetDiv).next().find('h4 > a').focus();       

      });
    }
  };
})(jQuery);
